import { Card } from "react-bootstrap";
import styled from "styled-components";
import { WitLabel } from "../shared/widgets/common";

// Re-export WitLabel as SectionTitle to match the style used across other managers
export { WitLabel as SectionTitle };

export const PageContainer = styled.div`
  padding: 0;
`;

export const SectionCard = styled(Card)`
  margin: 20px;
  border-radius: 8px;
`;

export const SectionCardBody = styled(Card.Body)`
  padding: 24px 28px;
`;

export const SectionText = styled.p`
  font-size: 13px;
  color: #909293;
  margin-bottom: 0;
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;
  label {
    font-size: 13px;
    font-weight: 600;
    color: #4a4a4a;
    display: block;
    margin-bottom: 4px;
  }
`;

export const ErrorText = styled.span`
  color: #dc3545;
  font-size: 12px;
  display: block;
  margin-top: 4px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 12px;
  padding: 20px;
`;

export const SectionDivider = styled.div`
  border-top: 1px solid #e9ecef;
  margin-top: 24px;
  padding-top: 24px;
`;

export const UrlInputWrapper = styled.div`
  position: relative;
  margin-top: 8px;

  svg {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    color: #909293;
    pointer-events: none;
  }

  input {
    padding-left: 34px;
  }
`;
